<template>
  <div>
    <ApplyInvoiceDetail></ApplyInvoiceDetail>

  </div>
</template>
<script>
import api from '@/apis/api.js';
export default {
  name: 'InvoiceDetail',
  data () {
    return {
    }
  },
  filters: {
  },
  watch: {
  },
  components: {
    ApplyInvoiceDetail: resolve => require(["@/components/InvoiceManage/ApplyInvoiceDetail.vue"], resolve),// 开票申请详情
  },
  methods: {
  },
  created() {
    
  },
  mounted () {
  },
  computed: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/InvoiceManage/InvoiceApplyDetail.vue